import HxTableResultCol from './main.vue'

/* istanbul ignore next */
HxTableResultCol.install = function(Vue) {
  Vue.component(HxTableResultCol.name, HxTableResultCol)
}

export default HxTableResultCol
